interface BadgeProps {
  children: React.ReactNode
  variant?: 'default' | 'primary' | 'success' | 'warning' | 'error'
  className?: string
}

export default function Badge({ children, variant = 'default', className = '' }: BadgeProps) {
  const variants = {
    default: 'bg-muted text-muted-foreground border-border',
    primary: 'bg-primary-muted text-primary border-primary',
    success: 'bg-success/10 text-success border-success',
    warning: 'bg-warning/10 text-warning border-warning',
    error: 'bg-error/10 text-error border-error',
  }
  
  return (
    <span className={`inline-flex items-center px-3 py-1 text-micro uppercase tracking-widest font-medium border ${variants[variant]} ${className}`}>
      {children}
    </span>
  )
}